
namespace SorAraBul.Definitions {

    @Serenity.Decorators.registerClass()
    export class OccupationGrid extends Serenity.EntityGrid<OccupationRow, any> {
        protected getColumnsKey() { return OccupationColumns.columnsKey; }
        protected getDialogType() { return OccupationDialog; }
        protected getIdProperty() { return OccupationRow.idProperty; }
        protected getInsertPermission() { return OccupationRow.insertPermission; }
        protected getLocalTextPrefix() { return OccupationRow.localTextPrefix; }
        protected getService() { return OccupationService.baseUrl; }
        protected getIsActiveProperty() { return OccupationRow.isActiveProperty; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}
